import React from 'react';
import { Form } from 'antd';
import { Input } from 'rsuite';

import Config from '../../config/Config'
import Cache from '../../frame/Cache';

import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import WidgetSelect from '../../widget/WidgetSelect';
import WidgetTable from './../../widget/WidgetTable';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetTreeTable from './../../widget/WidgetTreeTable';
import WidgetComponent from './../../widget/WidgetComponent';

import 'antd/dist/antd.css';

class DepartmentPrivilege extends WidgetComponent
{
    constructor( props )
    {
        super(props);

        let path, department;

        path = Config.getBasePath();

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }

        if( this.props.location!==undefined && this.props.location.state!==undefined )
        {
            department = this.props.location.state.department;
        }

        this.state = {
            path : path,
            domain : {},
            newDomain : {},
            checkDomains : undefined, 
            privilegeType : "D111",
            checkedKeys : undefined,
            checkedAreaDomains:undefined,
            data : undefined,
            columns : [
                { name: 'code', title: 'code', type: 'string', description: 'code', properties: { hidden: true }},
                { name: 'name', title: '地区名称', type: 'string', description: '地区名称', properties: { hidden: false }},
                { name: 'value', title: '地区编码', type: 'string', description: '地区编码', properties: { hidden: false }},
                { name: 'value', title: '数据权限', type: 'string', description: '数据权限', properties: { check:{name:"可访问"}}}
            ], 
            options : {
                rowKey : "value"
            },
            data2 : undefined,
            columns2 : [
                { name: 'value', title: '', type: 'string', description: '', properties: {width:5, check:{name:""}}},
                { name: 'field', title: '限制域字段', type: 'string', description: '限制域字段', properties: { hidden: false}},
                { name: 'independent', title: '独立权限', type: 'string', description: '独立权限',properties: { hidden: false}},
                { name: 'type', title: '限制域类型', type: 'string', description: '限制域类型', properties: { hidden: false}},
                { name: 'value', title: '限制域内容', type: 'string', description: '限制域内容', properties: { hidden: false}},
                { name: 'operation', title: '操作', type: 'string', description: '操作', 
                    properties: {
                        operations: [ { name: '编辑', click: "edit" }, { name: '删除', click: "remove" } ]
                    }
                }
            ],
            options2 : {
                isSerial : false,
                rowKey : "value",
                records : 10
            },
            layout : {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 },
            },
            typeOptions : {
                title:"权限类型"
            },
            typeData : [{label:'表达式',value:'EXPRESSION'},{label:'内容项', value:'ITEM'}],
            independentOptions : {
                title:"权限独立性"
            },
            independentData : [{label:'独立',value:1},{label:'不独立', value:2}],
            departmentDomainModelOptions : {
                title : "创建部门",
                confirm : "确定",
            },
            messageOptions : {
                title : "信息",
            },
            department : department!==undefined ? department : {},
            editDomainIndex:undefined,
            beforeParentPage:{}
        };
        
        this.onEvent = this.onEvent.bind(this);
        this.loadAreaData = this.loadAreaData.bind(this);
        this.onLoadAreaData = this.onLoadAreaData.bind(this);
        
        this.loadDepartmentDomain = this.loadDepartmentDomain.bind(this);
        this.onLoadDepartmentDomain = this.onLoadDepartmentDomain.bind(this);

        this.createDepartmentDomain = this.createDepartmentDomain.bind(this);
        this.createDepartmentDomainConfirm = this.createDepartmentDomainConfirm.bind(this);

        this.inputOnchange = this.inputOnchange.bind(this);
        this.typeOnSelect = this.typeOnSelect.bind(this);
        this.independentOnSelect = this.independentOnSelect.bind(this);

        this.editDomain = this.editDomain.bind(this);
        this.removeDomain = this.removeDomain.bind(this);
        this.removeDomains = this.removeDomains.bind(this);
        
        this.onCheck = this.onCheck.bind(this);   
        this.redrict = this.redrict.bind(this);   
        this.cancelPage = this.cancelPage.bind(this);   
        this.savePage = this.savePage.bind(this);
        this.onSavePage = this.onSavePage.bind(this);   

        this.buildDomain = this.buildDomain.bind(this);
        this.buildAreaDomain = this.buildAreaDomain.bind(this);
        
        this.domainOnCheck = this.domainOnCheck.bind(this);
    }

    componentDidMount()
    {
        this.setState({
            beforeParentPage:this.props.location.state.department
        })
        this.loadAreaData();
        this.loadDepartmentDomain(); 
    }

    /**
     * 取消页面
     */
    cancelPage()
    {
        this.loadAreaData();
        this.loadDepartmentDomain();
        this.redrict()
    }

    /**
     * 保存页面
     */
    savePage()
    {

        let { department, path, checkedAreaDomains } = this.state, domain = [], domainMap = {};

        domainMap = this.buildDomain( domainMap );

        domainMap = this.buildAreaDomain( domainMap );


        for(let key in domainMap )
        {
            domain.push(domainMap[key]);
        }
        
        let params = {
            id : department.id,
            domain: domain
        }
        
        WidgetAjax.ajax({url:path + 'group/set_domain', params:params, callback:this.onSavePage});
    }

    /**
     * 保存页面回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onSavePage(result, params)
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = true ; 
        if( result.status===0 )
        {
            messageOptions["message"] = "部门权限设置成功！" ;
        }
        else
        {
            messageOptions["message"] = "部门权限设置失败！" ;
        }

        this.messageRef.open();
        setTimeout(()=>{
            this.props.history.push('/home/group');
        },1500)
    }

    departmentDomainModelRef = ( ref ) => {
        this.departmentDomainModelRef = ref;
    }

    messageRef = ( ref ) => {
        this.messageRef = ref;
    }

    /**
     * 创建地区限制域map
     * @param {*} domainMap 
     * @returns 
     */
    buildAreaDomain( domainMap )
    {
        let { checkedAreaDomains } = this.state,newAreaDomain = {},domainContents = [];
        if(checkedAreaDomains != undefined && checkedAreaDomains != null && checkedAreaDomains.length>0)
        {
            newAreaDomain[checkedAreaDomains[0].code] = {}

            newAreaDomain[checkedAreaDomains[0].code].field = checkedAreaDomains[0].code;
    
            checkedAreaDomains.forEach((item=>{domainContents.push(item.value)}));
            
            newAreaDomain[checkedAreaDomains[0].code].values = [{independent: true,type: "ITEM",contents: domainContents}];
        }
        

        // if( checkedAreaDomains!==undefined && checkedAreaDomains.length>0 )
        // {
        //     for( let item of checkedAreaDomains )
        //     {
        //         let field = item.code, domain = {}; 
                
        //         if( domainMap[field]!==undefined && domainMap[field]!==null )
        //         {
        //             domain = domainMap[field]; 
        //         }
        //         else
        //         {
        //             domain["field"] = field;
        //         }

        //         let isExit = false;

        //         if( domain["values"]!==undefined && domain["values"]!==null && domain["values"].length>0 )
        //         {
        //             for( let i = 0; i < domain["values"].length; i++ )
        //             {
        //                 let value = domain["values"][i];

        //                 if( value.independent===true && value.type==="item")
        //                 {
        //                     if( value.contents===undefined || value.contents===null )
        //                     {
        //                         value.contents = [];
        //                     }
        //                     value.contents.push(item.value);

        //                     domain["values"][i] = value;

        //                     isExit = true;
        //                 }
        //             }  
        //         }
        //         if( isExit===false )
        //         {
        //             domain["values"] = [];

        //             let contents = [];

        //             contents.push(item.value);

        //             let value = {
        //                 type : "ITEM",
        //                 independent : true,
        //                 contents : contents
        //             }

        //             domain["values"].push(value);
        //         }

        //         domainMap[field] = domain;
        //     }
        // }


        domainMap = newAreaDomain;
        return domainMap;
    }

    /**
     * 自定义限制域创建
     * @param {*} domainMap 
     * @returns 
     */
    buildDomain( domainMap )
    {
        let { data2 } = this.state;

        if( data2!==undefined && data2.length>0 )
        {
            for( let item of data2 )
            {
                let field = item.field, domain = {}; 
                
                if( domainMap[field]!==undefined && domainMap[field]!==null )
                {
                    domain = domainMap[field]; 
                }
                else
                {
                    domain["field"] = field;
                }
                
                let isExit = false;

                if( domain["values"]!==undefined && domain["values"]!==null && domain["values"].length>0 )
                {
                    for( let i=0; i<domain["values"].length; i++ )
                    {
                        let value = domain["values"][i];

                        let independent = item.independent!=="否" ? true : false;

                        if( value.independent===independent && value.type===item.type )
                        {
                            isExit = true;

                            if( value.contents===undefined || value.contents===null )
                            {
                                value.contents = [];
                            }

                            value.contents.push(item.value);

                            domain["values"][i] = value;
                        }
                    }
                }

                if( isExit===false )
                {
                    domain["values"] = [];

                    let contents = [];

                    contents.push(item.value);

                    let value = {
                        type : item.type,
                        independent : item.independent!=="否" ? true : false,
                        contents : contents
                    }

                    domain["values"].push(value);
                }

                domainMap[field] = domain;
            }
        }

        return domainMap;
    }

    /**
     * 地区限制/自定义限制切换
     * @param {*} privilegeType 
     */
    changeType( privilegeType )
    {
        this.setState({privilegeType:privilegeType});
    }

    /**
     * 加载地区数据
     */
    loadAreaData()
    {
        const { path } = this.state;

        let params = {
            dimension: {"code":"D111001","hierarchy":3}
        }

        WidgetAjax.ajax({url:path + 'widget/dimension', params:params, callback:this.onLoadAreaData});
    }

    /**
     * 加载地区数据回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onLoadAreaData( result, params )
    {
        if( result.status===0 )
        {
            let data = [];

            if( result.results!==undefined && result.results.length>0 )
            {
                for( let j in result.results)
                {
                    let items = this.buildFilterData(result.results[j], -1);

                    data.push(...items);
                } 
            }

            this.setState({data:data}); 
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 创建地区数据
     * @param {*} data 
     * @param {*} parent 
     * @returns 
     */
    buildFilterData( data, parent)
    {
        let items = [];

        for( let i=0; i<data.values.length; i++ )
        {
            let node = {};
            
            node.role = parent;
            node.name = data.values[i].name;
            node.code = data.code;

            node.value = data.values[i].value;

            if( data.values[i]!==undefined && data.values[i].subdimension !== undefined && data.values[i].subdimension.values.length > 0 )
            {
                node.children = this.buildFilterData(data.values[i].subdimension, data.values[i].value);
            }
            
            items.push(node);
        }

        return items;
    }

    /**
     * 加载部门限制域
     */
    loadDepartmentDomain()
    {
        const { path, department} = this.state;

        let params = {
            id: department.id
        }

        WidgetAjax.ajax({url:path + 'group/domain', params:params, callback:this.onLoadDepartmentDomain});
    }


    /**
     * 加载部门限制域回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onLoadDepartmentDomain( result, params )
    {
        if( result.status===0 )
        {
            let data = [], checkedKeys = [];

            if( result.results!==undefined && result.results.length>0 )
            {
                for( let item of result.results )
                {
                    if( item.values!==undefined && item.values.length>0 )
                    {
                        for( let value of item.values)
                        {
                            if( item.field.substring(0,4)==="D111" && value.type==="ITEM")
                            {
                                if( value.contents!==undefined && value.contents.length>0 )
                                {
                                    for( let content of value.contents)
                                    {
                                        checkedKeys.push(content);
                                    }
                                }
                            }
                            else
                            {
                                if( value.contents!==undefined && value.contents.length>0 )
                                {
                                    for( let content of value.contents)
                                    {
                                        let domain = {
                                            field : item.field,
                                            independent : value.independent===true ? '是' : '否',
                                            type : value.type,
                                            value : content
                                        };

                                        data.push(domain);
                                    } 
                                }
                            }
                        }
                    }
                } 
            }

            this.setState({data2:data, checkedKeys:checkedKeys}); 
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

   

    /**
     * 表格点击事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
    onEvent(type, data, value, event)
    {
        if( data!==undefined )
        {
            data = JSON.parse(data);
        }

        switch( type )
        {
            case "remove":
            {
                this.removeDomain(data);
                break;
            }
            case "edit" : 
            {
                this.editDomain(data);
                break
            }
            default:
                break;
        }
    }

    /**
     * 删除自定义限制域
     * @param {*} data 
     */
    removeDomain( data )
    {
        let { data2 } = this.state;

        for( let i=0; i<data2.length; i++ )
        {
            let item = data2[i];

            if( data.field===item.field && data.type===item.type && data.independent===item.independent && data.value===item.value )
            {
                data2.splice(i, 1);
            }
        }

        this.setState(data2);
    }

    /**
     * 批量删除限制域
     */
    removeDomains()
    {
        let { checkDomains, data2, messageOptions } = this.state, title, isFirst = true;

        if( checkDomains!==undefined && checkDomains.length>0 )
        {
            for( let data of checkDomains)
            {
                for( let i=0; i<data2.length; i++ )
                {
                    let item = data2[i];

                    if( data.field===item.field && data.type===item.type && data.independent===item.independent && data.value===item.value )
                    {
                        data2.splice(i, 1);

                        if( isFirst )
                        {
                            title = data.value;
                            isFirst = false
                        }
                        else
                        {
                            title += ", " +  data.value;
                        }

                        break;
                    }
                }
            }  

            messageOptions["isMessage"] = true ;

            messageOptions["message"] = "部门权限'" + title +"' 删除成功！" ;
    
            this.setState({data2:data2, checkDomains:[], messageOptions:messageOptions});
    
            this.messageRef.open();
        }
    }

    /**
     * 限制域内容和字段回调函数
     * @param {*} value 
     * @param {*} type 
     */
    inputOnchange(value, type)
    {
        switch( type )
        {
            case "field":
            {
                this.state.newDomain["field"] = value;
                break;
            }
            case "value":
            {
                this.state.newDomain["value"] = value;
                break;
            }
            default:
                break;
        }
    }

    /**
     * 限制域值类型选择回调函数
     * @param {*} value 
     * @param {*} item 
     * @param {*} event 
     */
    typeOnSelect(value, item, event)
    {
        this.state.newDomain["type"] = value;
    }

    /**
     * 限制域独立性选择回调函数
     * @param {*} value 
     * @param {*} item 
     * @param {*} event 
     */
    independentOnSelect(value, item, event)
    {
        this.state.newDomain["independent"] = value;
    }

    /**
     * 创建部门限制域
     */
    createDepartmentDomain()
    {
        this.setState({ domain:{}, newDomain:{}, isCreate:true},()=>{
            this.departmentDomainModelRef.open()
        })

    }

    /**
     * 编辑部门限制域
     * @param {*} data 
     */
    editDomain( data )
    {
        let { data2 } = this.state;

        let index = data2.findIndex((item) => item.field === data.field);

        if( data!==undefined )
        {
            data["independent"] = data["independent"] === "是" ? true : false;

            this.setState({domain:data, newDomain:data, isCreate:false, editDomainIndex:index},()=>{
                this.departmentDomainModelRef.open();
            });
    
        }
    }

    /**
     * 创建部门限制域确认函数
     */
    createDepartmentDomainConfirm()
    {
        let { domain, data2, newDomain, messageOptions, isCreate, editDomainIndex} = this.state;

        messageOptions["isMessage"] = true ;

        if( isCreate )
        {

            newDomain["independent"] = newDomain["independent"] === 1 ? "是" : "否" ;

            data2.push(newDomain);

            messageOptions["message"] = "部门权限'" + newDomain.value +"' 新增成功！" ;
        }
        else
        {
            newDomain["independent"] = newDomain["independent"] === 1 ? "是" : "否" ;
            
            data2.splice(editDomainIndex,1,newDomain)
            
            this.setState({data2:data2})

            messageOptions["message"] = "部门权限'" + domain.value +"' 修改成功！" ;
        }

        this.setState({data2:data2, newDomain:{}, messageOptions:messageOptions});

        this.messageRef.open();
    }

    /**
     * 自定义限制域表格多选框函数
     * @param {*} data 
     */
    onCheck( data )
    {
        let checkedKeys = [], checkedAreaDomains = [];

        if( data!==undefined && data.length>0 )
        {
            for( let item of data )
            {
                checkedKeys.push(item.value);
            }
            
            checkedAreaDomains.push(...data);
        }

        
        this.setState({checkedKeys:checkedKeys, checkedAreaDomains:checkedAreaDomains});
    }

    /**
     * 区域限制域表格选择函数
     * @param {*} data 
     */
    domainOnCheck( data )
    {
        this.state["checkDomains"] = data;
    }
   
    /**
    * 跳转
    */
    redrict()
    {
        this.props.history.push('/home/group');
    }

    render()
    {
        const { department, privilegeType, data, options, columns, checkedKeys, columns2, data2, options2, 
            domain, typeData, independentData, independentOptions, typeOptions, departmentDomainModelOptions, 
            messageOptions, isCreate, newDomain, beforeParentPage} = this.state;
        
        departmentDomainModelOptions["confirmFunction"] = this.createDepartmentDomainConfirm;

        return (
            <div className="page  page-overflow ">
                <div className="page-weidu">
                    <div className="page-title">
                        <div className='go_back' onClick={this.redrict}><img src={require('./img/icon/back.svg')}/></div>
                        <p className='go_back_title' style={{marginTop:"0"}}>分组权限管理 /<span style={{color:"#646464"}}>{" " + beforeParentPage.name}</span></p>
                        {/* <div className="page-title-img"><img src={require("./img/ml-ztzt.png")} alt=""></img></div>
                        <span className="page-title-font"> 用户部门权限配置 </span> / <span className="page-title-path-font">{department.name}</span> */}
                    </div>
                </div>
                
                <div className="page-content department" >
                    <div className="content-canvas content-top-frame-height height-100" style={{position:"relative",overflow:"hidden"}}>
                        <div className="content-title" style={{padding:"0"}}>
                            <div className="frame-sheet" style={{marginBottom:"0"}}>
                                <label onClick={ ()=>{this.changeType("D111")} }   className={ privilegeType==="D111" ? "label_common label_active click" : "label_common click" }>地区权限</label>
                                <label onClick={ ()=>{this.changeType("custom")} } className={ privilegeType==="custom" ? "label_common label_active click" : "label_common click" }>自定义权限</label>
                            </div>
                        </div>
                        <div className="content-body" style={ privilegeType==="D111" ? { display:"block", clear:'both' } : {display:"none"}}>
                            <WidgetTreeTable options={options} columns={columns} data={data} checkData={checkedKeys} onCheck={this.onCheck} notify={this.onEvent}></WidgetTreeTable>
                        </div>

                        <div className="content-body" style={ privilegeType==="custom" ? {display:"block", clear:'both'} : {display:"none"} }>
                            <div className="content-title Addroles batch" style={{padding:" 0 24px"}}>
                                <div className="remove-button" style={{float: 'left'}}>
                                    <span className="addUser" onClick={this.removeDomains}>批量删除</span>
                                </div>

                                <div className="button" style={{float: 'right',margin:"0"}}>
                                    <span className="addUser" onClick={this.createDepartmentDomain}>新增权限</span>
                                </div>
                                
                            </div>
                            <WidgetTable options={options2} columns={columns2} data={data2} notify={this.onEvent} onCheck={this.domainOnCheck}></WidgetTable>
                        </div>

                        {/* <div className="content-footer" style={  data!==undefined && data!==null ? privilegeType==="D111" ? { display:"block", clear:'both',paddingTop:"11px" } : {display:"none"} : {display:"none"}}> */}
                        <div className="content-footer">
                            <div className="footer-button">
                                <div className="button footer-submit click" onClick={this.savePage}>
                                    <span className="addUser">保存</span>
                                </div>
                                <div className="button footer-cancel click" onClick={this.cancelPage}>
                                    <span className="addUser">取消</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <WidgetModal options={departmentDomainModelOptions} onRef={this.departmentDomainModelRef} >
                    <div className="domain-model">
                        <Form layout="vertical"  name="basic">
                            <Form.Item label="权限字段" name="field">
                                <Input defaultValue={newDomain.field} placeholder="权限字段" onChange={(value) => {this.inputOnchange(value, "field")}}></Input> 
                            </Form.Item>
                            <Form.Item label="是否独立权限" name="independent">
                                <WidgetSelect options={independentOptions} data={independentData} defaultValue={ isCreate ? "" : newDomain.independent ? 1 : 2 } onSelect={this.independentOnSelect}></WidgetSelect>
                            </Form.Item>
                            <Form.Item label="权限类型" name="type">
                                <WidgetSelect options={typeOptions}  data={typeData} defaultValue={newDomain.type} onSelect={this.typeOnSelect}></WidgetSelect>
                            </Form.Item>
                            <Form.Item label="权限内容" name="value">
                                <Input componentClass="textarea" rows={4}  defaultValue={newDomain.value} placeholder="权限内容" onChange={(value) => {this.inputOnchange(value, "value")}} />
                            </Form.Item>
                        </Form>
                        
                    </div>
                </WidgetModal>

                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
          </div>
        );
    }
}

export default DepartmentPrivilege
